import React from "react";
import { Link } from "react-router-dom";
import SEO from "../components/SEO";

const NOMORE = [
  "Chercher le bon destinataire dans l'annuaire santé",
  "Recopier les informations personnelles du patient",
  "Recopier les valeurs de l'examen de vue",
  "Retrouver et ressaisir la date de la prescription d'origine",
];

export default function MessageType() {
  return (
    <div className="mct">
      <SEO
        title="Le courrier type envoyé à l'ophtalmologiste · MetaConnect"
        description="À quoi ressemble le courrier d'adaptation transmis à l'ophtalmologiste ou à l'orthoptiste : patient, corrections et date de prescription repris du logiciel."
        canonical="/message-type"
      />
      <style>{CSS}</style>

      <section className="mct-hero">
        <div className="mct-wrap">
          <span className="mct-pill">Exemple</span>
          <h1>Le message qui part chez l'ophtalmologiste ou l'orthoptiste</h1>
          <p className="mct-lede">
            Vous avez adapté une correction. Votre logiciel a préparé le courrier avec le patient, le
            prescripteur et les valeurs de réfraction. Vous relisez, vous modifiez si besoin, vous
            envoyez. Voici ce que l'ophtalmologiste ou l'orthoptiste reçoit dans sa messagerie
            sécurisée.
          </p>
          <div className="mct-demo">
            <svg viewBox="0 0 24 24" aria-hidden="true">
              <circle cx="12" cy="12" r="9" />
              <path d="M12 8v5M12 16.5v.01" />
            </svg>
            Établissement, praticiens et patient fictifs — exemple de mise en forme
          </div>
        </div>
      </section>

      <section className="mct-sec">
        <div className="mct-wrap">
          <div className="mct-mail">
            <div className="mct-top">
              <i />
              <i />
              <i />
              <span>Messagerie sécurisée de santé</span>
            </div>

            <div className="mct-hd">
              <h2>
                Information relative à une adaptation de prescription en cours de validité — Camille
                RIVIÈRE
              </h2>
              <div className="mct-rows">
                <div className="mct-row">
                  <b>De</b>
                  <span>
                    optique-rivage@opticiens.mssante.fr
                    <em className="mct-orga">Boîte de l'établissement</em>
                  </span>
                </div>
                <div className="mct-row">
                  <b>À</b>
                  <span>helene.marchand@medecin.mssante.fr</span>
                </div>
                <div className="mct-row">
                  <b>Date</b>
                  <span>Mercredi 12 août 2026, 13:03</span>
                </div>
                <div className="mct-row">
                  <b>Patient</b>
                  <span>Camille RIVIÈRE, née le 12/04/1979 — identité qualifiée</span>
                </div>
              </div>
            </div>

            <div className="mct-body">
              <p>Cher Docteur,</p>
              <p>
                J'ai reçu ce jour Mme Camille RIVIÈRE, pour laquelle vous avez établi une
                prescription en date du 05/08/2021.
              </p>
              <p>
                À la suite d'un examen complémentaire de la réfraction, une adaptation des
                corrections optiques s'est avérée nécessaire. Conformément à l'article L.4362-10 du
                Code de la santé publique, l'opticien-lunetier est autorisé à adapter une
                prescription en cours de validité, sauf opposition expresse du prescripteur.
              </p>
              <p>Les corrections proposées sont les suivantes :</p>
              <div className="mct-corr">
                <div>
                  <b>Œil droit</b>
                  <span>Sph −0,50 · Add +0,75</span>
                </div>
                <div>
                  <b>Œil gauche</b>
                  <span>Sph −0,50 (Cyl −0,75 axe 90°) · Add +0,75</span>
                </div>
                <div className="mct-acuite">
                  <b>ODG</b>
                  <span>Acuité VL 10/10 · Acuité VP P2</span>
                </div>
              </div>
              <p>
                Cette modification a été déposée automatiquement dans le dossier médical partagé du
                patient afin de garantir la traçabilité.
              </p>
              <p>
                Je reste à votre disposition pour tout complément d'information et pour recueillir
                vos observations si nécessaire.
              </p>

              <div className="mct-sig">
                Sincères salutations,
                <b>Julien MERCIER — Opticien-lunetier</b>
                Optique Rivage · 45150 Jargeau
                <em>Envoyé depuis la boîte de l'établissement — optique-rivage@opticiens.mssante.fr</em>
              </div>

              <div className="mct-trace">
                <svg viewBox="0 0 24 24" aria-hidden="true">
                  <path d="M20 6L9 17l-5-5" />
                </svg>
                Message remis · numéro de traçabilité horodaté remonté dans votre logiciel · document
                déposé au dossier médical partagé
              </div>
            </div>
          </div>

          <div className="mct-after">
            <h2>Ce que vous n'avez pas eu à faire</h2>
            <ul className="mct-nomore">
              {NOMORE.map((n) => (
                <li key={n}>
                  <svg viewBox="0 0 24 24" aria-hidden="true">
                    <path d="M18 6L6 18M6 6l12 12" />
                  </svg>
                  <span>{n}</span>
                </li>
              ))}
            </ul>

            <div className="mct-hl">
              <div className="mct-hlc">
                <h3>Un format reconnu par la filière</h3>
                <p>
                  Ce message type est validé par l'ensemble des syndicats de la filière visuelle. Il
                  permet une structuration directe dans le logiciel métier des ophtalmologistes et
                  des orthoptistes : votre correspondant n'a rien à recopier non plus.
                </p>
              </div>
              <div className="mct-hlc">
                <h3>Et vous restez maître du texte</h3>
                <p>
                  Avant l'envoi, le message est entièrement modifiable. Vous ajoutez une observation,
                  vous retirez une ligne, vous précisez un contexte — c'est votre courrier, le
                  logiciel ne fait que vous éviter la saisie.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="mct-cta">
        <div className="mct-wrap">
          <h2>Vous voulez le voir tourner sur vos propres dossiers ?</h2>
          <p>
            Quinze minutes suffisent pour comprendre le parcours complet, de l'adaptation à la preuve
            de remise.
          </p>
          <Link className="mct-btn" to="/demo">
            Prendre rendez-vous
          </Link>
        </div>
      </section>
    </div>
  );
}

const CSS = `
.mct{
  --ground:#F5F5F5;--surface:#fff;--line:#E6E8EC;--text:#0F172A;--muted:#5A6478;
  --blue:#0080FF;--blue700:#0069D1;--bsoft:#EAF4FF;--bline:#CFE4FF;
  background:var(--ground);color:var(--text);
  font-family:"Instrument Sans",-apple-system,BlinkMacSystemFont,"Segoe UI",Roboto,sans-serif;
  -webkit-font-smoothing:antialiased;
}
.mct *{box-sizing:border-box}
.mct h1,.mct h2,.mct h3{margin:0;color:var(--text);font-weight:600;text-wrap:balance}
.mct h1{font-size:clamp(29px,3.6vw,40px);line-height:1.14;letter-spacing:-.02em}
.mct p{margin:0;color:var(--muted);line-height:1.6}
.mct ul{list-style:none;margin:0;padding:0}
.mct-wrap{max-width:1000px;margin:0 auto;padding:0 28px}

.mct-pill{display:inline-flex;border-radius:999px;background:#E7ECF3;color:#45526B;
  font-size:11.5px;font-weight:600;letter-spacing:.11em;text-transform:uppercase;padding:7px 15px}
.mct-hero{padding:82px 0 34px;text-align:center}
.mct-hero h1{margin:16px auto 0;max-width:20ch}
.mct .mct-lede{max-width:64ch;margin:16px auto 0;font-size:16.5px}
.mct-demo{display:inline-flex;align-items:center;gap:9px;background:#FEF6E7;border:1px solid #F3DCA8;
  color:#8A6414;border-radius:999px;font-size:12.6px;font-weight:600;padding:8px 16px;margin-top:22px}
.mct-demo svg{width:15px;height:15px;stroke:currentColor;fill:none;stroke-width:2;
  stroke-linecap:round;stroke-linejoin:round;flex:0 0 15px}

.mct-sec{padding:34px 0 62px}
.mct-mail{max-width:760px;margin:0 auto;background:#fff;border:1px solid var(--line);
  border-radius:16px;overflow:hidden;box-shadow:0 26px 60px -34px rgba(15,23,42,.4)}
.mct-top{background:#F2F4F7;border-bottom:1px solid var(--line);padding:13px 22px;
  display:flex;align-items:center;gap:10px}
.mct-top i{width:9px;height:9px;border-radius:50%;background:#D3D8E0;display:block}
.mct-top span{margin-left:auto;font-size:12.2px;color:#7C8698}
.mct-hd{padding:22px 26px 18px;border-bottom:1px solid var(--line)}
.mct-hd h2{font-size:17px;line-height:1.35;margin-bottom:14px}
.mct-rows{display:grid;gap:8px}
.mct-row{display:flex;gap:12px;font-size:13.2px;align-items:baseline}
.mct-row b{flex:0 0 84px;color:#8A93A5;font-weight:600;font-size:11.4px;letter-spacing:.08em;
  text-transform:uppercase}
.mct-row span{color:#25304A}
.mct-orga{display:inline-block;margin-left:8px;background:#EAF4FF;border:1px solid var(--bline);
  color:#0B62C4;border-radius:999px;font-size:11px;font-weight:600;padding:2px 9px;
  font-style:normal;vertical-align:middle}
.mct-body{padding:24px 26px 28px}
.mct-body p{color:#25304A;font-size:14.2px;line-height:1.72;margin-bottom:14px}
.mct-corr{margin:0 0 14px;padding:14px 18px;background:#F7F9FC;border:1px solid var(--line);
  border-radius:12px;display:grid;gap:7px}
.mct-corr div{display:flex;gap:12px;font-size:14px;flex-wrap:wrap;align-items:baseline}
.mct-corr b{flex:0 0 82px;font-weight:600;color:#0F172A}
.mct-corr span{font-variant-numeric:tabular-nums;color:#25304A}
.mct-acuite{border-top:1px solid #E4E8EE;padding-top:8px;margin-top:1px}
.mct-corr .mct-acuite span{color:#5A6478}
.mct-sig{margin-top:20px;padding-top:16px;border-top:1px solid var(--line);font-size:13.4px;
  line-height:1.65;color:#3D4759}
.mct-sig b{display:block;color:#0F172A}
.mct-sig em{display:block;font-style:normal;color:#7C8698;font-size:12.6px;margin-top:4px}
.mct-trace{margin-top:16px;display:flex;align-items:flex-start;gap:11px;background:#F0FAF3;
  border:1px solid #C7E9D4;border-radius:12px;padding:12px 16px;font-size:12.9px;
  color:#256B41;line-height:1.5}
.mct-trace svg{width:16px;height:16px;flex:0 0 16px;margin-top:1px;stroke:#1E8A4C;fill:none;
  stroke-width:2;stroke-linecap:round;stroke-linejoin:round}

.mct-after{max-width:760px;margin:38px auto 0}
.mct-after h2{font-size:21px;text-align:center;margin-bottom:20px}
.mct-nomore{display:grid;grid-template-columns:repeat(2,1fr);gap:11px 22px;background:#fff;
  border:1px solid var(--line);border-radius:16px;padding:24px 26px}
.mct-nomore li{display:flex;gap:11px;font-size:14px;line-height:1.5;color:#3D4759;
  align-items:flex-start}
.mct-nomore svg{width:15px;height:15px;flex:0 0 15px;margin-top:4px;stroke:#C2410C;fill:none;
  stroke-width:2.4;stroke-linecap:round}
.mct-hl{display:grid;grid-template-columns:repeat(2,1fr);gap:14px;margin-top:14px}
.mct-hlc{background:var(--bsoft);border:1px solid var(--bline);border-radius:14px;padding:20px}
.mct-hlc h3{font-size:15px;margin-bottom:8px;color:#0B4E9E}
.mct-hlc p{font-size:13.4px;line-height:1.6;color:#2C4A70}

.mct-cta{background:var(--blue);padding:56px 0;text-align:center}
.mct-cta h2{color:#fff;font-size:clamp(22px,2.6vw,30px);margin-bottom:12px}
.mct-cta p{color:rgba(255,255,255,.9);font-size:15.5px;max-width:60ch;margin:0 auto 24px}
.mct-btn{display:inline-flex;align-items:center;justify-content:center;border-radius:999px;
  background:#fff;color:var(--blue);font-weight:600;font-size:15px;text-decoration:none;
  padding:13px 28px}
.mct-btn:hover{background:#EAF4FF;color:var(--blue)}

@media (max-width:820px){
  .mct-nomore,.mct-hl{grid-template-columns:1fr}
  .mct-hero{padding:56px 0 28px}
}
.mct a:focus-visible{outline:2px solid var(--blue);outline-offset:3px;border-radius:6px}
`;
